import React from 'react'

const PausedCol = ({ paused }) => {
    const isNotZeroPaused = paused.count > 0
    return (
        <p className={`department_employe_count_mobile ${paused.top === 1 && isNotZeroPaused ? "top_color_red" : paused.top === 2 && isNotZeroPaused ? "top_color_orange" : "default_color"}`}> {paused.count}</p >
    )
}

export default PausedCol